import {
  ALL_SILHOUETTE,
  ALL_PAPER_TYPES,
  BASE_PAPER_TYPES,
  ALL_FOIL_COLORS
} from 'cards/constants/CardLevelOptions';

export const CARD_TYPES = {
  invitation: 'INVITATION',
  invitationEnvelope: 'INVITATION_ENVELOPE',
  std: 'SAVE_THE_DATE',
  ctd: 'CHANGE_THE_DATE',
  thankyou: 'THANK_YOU',
  menu: 'MENU',
  program: 'PROGRAM',
  placecards: 'PLACE_CARDS',
  holiday: 'HOLIDAY',
  enclosure: 'ENCLOSURE',
  rsvp: 'RSVP',
  rsvpEnvelope: 'RSVP_ENVELOPE',
};

export const CARD_TYPES_WITH_INFO_BANNER = [
  CARD_TYPES.std,
  CARD_TYPES.ctd,
  CARD_TYPES.invitation,
  CARD_TYPES.enclosure,
  CARD_TYPES.placecards,
  CARD_TYPES.thankyou,
  CARD_TYPES.holiday
];

export const CARD_TYPES_WITH_SAMPLE = [
  CARD_TYPES.invitation,
  CARD_TYPES.std,
  CARD_TYPES.menu,
  CARD_TYPES.program,
  CARD_TYPES.enclosure,
];

export const AVAILABLE_PAPER_OPTIONS_BY_CARD_TYPE = {
  INVITATION: {
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: ALL_SILHOUETTE,
  },
  SAVE_THE_DATE: {
    size: ['petite', '5x7', 'postcard'],
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: ALL_SILHOUETTE,
  },
  CHANGE_THE_DATE: {
    size: ['petite', 'postcard'],
    'foil-color': null,
    'paper-type': BASE_PAPER_TYPES,
    silhouette: null,
  },
  THANK_YOU: {
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
  },
  MENU: {
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: ALL_SILHOUETTE,
  },
  PROGRAM: {
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: ALL_SILHOUETTE,
  },
  PLACE_CARDS: {
    'paper-type': ['smooth', 'eggshell', 'pearlized', 'linen', 'felt'],
  },
  HOLIDAY: {
    size: ['folded-petite', '5x7', 'postcard'],
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: ALL_SILHOUETTE,
  },
  ENCLOSURE: {
    'foil-color': ALL_FOIL_COLORS,
    'paper-type': ALL_PAPER_TYPES,
    silhouette: ALL_SILHOUETTE,
  },
};

export const AVAILABLE_MAGNET_OPTIONS_BY_CARD_TYPE = {
  SAVE_THE_DATE: {
    size: ['magnet', '5x7', 'postcard'],
    finish: ['glossy', 'matte'],
    silhouette: ['square', 'rounded'],
  },
  HOLIDAY: {
    size: ['magnet', '5x7', 'postcard'],
    finish: ['glossy', 'matte'],
    silhouette: ['square', 'rounded'],
  },
};

export const AVAILABLE_TYPE_OPTIONS_BY_CARD_TYPE = {
  INVITATION: ['paper'],
  SAVE_THE_DATE: ['paper', 'magnet'],
  CHANGE_THE_DATE: ['paper'],
  THANK_YOU: ['paper'],
  MENU: ['paper'],
  PROGRAM: ['paper'],
  HOLIDAY: ['paper', 'magnet'],
  ENCLOSURE: ['paper'],
};

// for Customization:
export const ORDERED_CUSTOMIZATION_TYPES = [
  'INVITATION',
  'SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'DETAILS',
  'MENU',
  'PROGRAM',
  'PLACE_CARDS',
  'THANK_YOU',
  'RSVP',
  'RSVP_ENVELOPE',
  'INVITATION_ENVELOPE',
  'ENVELOPE',
  'HOLIDAY',
];

export const PRIMARY_CUSTOMIZATION_TYPES = [
  'INVITATION',
  'SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'ENCLOSURE',
  'MENU',
  'PROGRAM',
  'PLACE_CARDS',
  'THANK_YOU',
  'HOLIDAY',
];

export const ENABLED_SAMPLE_ORDER_CARD_TYPES = [CARD_TYPES.invitation, CARD_TYPES.std];
export const ENABLED_SAMPLE_ORDER_ALL_CARD_TYPES = [CARD_TYPES.invitation, CARD_TYPES.std, CARD_TYPES.ctd, CARD_TYPES.menu, CARD_TYPES.program, CARD_TYPES.enclosure];



export const PROJECT_COPY_MAP = {
  [CARD_TYPES.invitation]: {
    title: 'Wedding Invitation'
  },
  [CARD_TYPES.std]: {
    title: 'Save The Date'
  },
  [CARD_TYPES.ctd]: {
    title: 'Change The Date'
  },
  [CARD_TYPES.thankyou]: {
    title: 'Thank You Card'
  },
  [CARD_TYPES.menu]: {
    title: 'Menu'
  },
  [CARD_TYPES.enclosure]: {
    title: 'Enclosure Card'
  },
  [CARD_TYPES.program]: {
    title: 'Program Card'
  },
  [CARD_TYPES.placecards]: {
    title: 'Place Cards'
  },
  [CARD_TYPES.holiday]: {
    title: 'Holiday Card'
  }
};

export const HERO_COPY = {
  [CARD_TYPES.invitation]: {
    header: 'Wedding Invitations',
    description: 'Invite guests with the perfect stationery that matches your wedding style.'
  },
  [CARD_TYPES.std]: {
    header: 'Save The Dates',
    subheader: '',
    description:
      'Set the tone for your wedding and choose a beautiful design that shows off your style.'
  },
  [CARD_TYPES.ctd]: {
    header: 'Change The Dates',
    subheader: '',
    description:
      'Set the tone for your wedding and choose a beautiful design that shows off your style.'
  },
  DETAILS: {
    header: 'Enclosure Cards',
    subheader: '',
    description: 'Complete your invitation suite and share all your wedding details with guests.'
  },
  [CARD_TYPES.menu]: {
    header: 'Wedding Menus',
    subheader: '',
    description:
      'Show guests your meal options on gorgeous cards that match your suite.'
  },
  [CARD_TYPES.program]: {
    header: 'Wedding Programs',
    subheader: '',
    description: 'Choose a design to highlight your unique ceremony details, fun facts, and more.'
  },
  [CARD_TYPES.thankyou]: {
    header: 'Thank You Cards',
    subheader: '',
    description:
      'Write your thoughtful notes on a special design. You can even add a custom wedding photo.'
  },
  [CARD_TYPES.holiday]: {
    header: 'Holiday Cards',
    subheader: '',
    description:
      'Send your season’s greetings with a unique design your friends and family will love.'
  },
  [CARD_TYPES.placecards]: {
    header: ' Place Cards',
    subheader: '',
    description:
      'Help your guests find their reception table with these elegant designs.'
  },
};

export const PLP_MODULE_GROUP_TAGS = {
  DETAILS: 'invites-plp-enclosure',
  ENCLOSURE: 'invites-plp-enclosure',
  HOLIDAY: 'invites-plp-holiday',
  INVITATION: 'invites-plp-invitation',
  MENU: 'invites-plp-menu',
  PLACE_CARDS: 'invites-plp-placecard',
  PROGRAM: 'invites-plp-program',
  SAVE_THE_DATE: 'invites-plp-savethedate',
  CHANGE_THE_DATE: 'invites-plp-changethedate',
  THANK_YOU: 'invites-plp-thankyou',
};

export const PDP_MODULE_GROUP_TAGS = {
  DETAILS: 'invites-pdp-enclosure',
  ENCLOSURE: 'invites-pdp-enclosure',
  HOLIDAY: 'invites-pdp-holiday',
  INVITATION: 'invites-pdp-invitation',
  MENU: 'invites-pdp-menu',
  PLACE_CARDS: 'invites-pdp-placecard',
  PROGRAM: 'invites-pdp-program',
  SAVE_THE_DATE: 'invites-pdp-savethedate',
  CHANGE_THE_DATE: 'invites-pdp-changethedate',
  THANK_YOU: 'invites-pdp-thankyou',
};

export const ROUTES_PLP_LEAD_CARD = {
  invitations: {
    leadCardType: 'INVITATION'
  },
  'save-the-date': {
    leadCardType: 'SAVE_THE_DATE'
  },
  'change-the-date': {
    leadCardType: 'CHANGE_THE_DATE'
  },
  'thank-you-cards': {
    leadCardType: 'THANK_YOU'
  },
  menus: {
    leadCardType: 'MENU'
  },
  enclosures: {
    leadCardType: 'DETAILS'
  },
  programs: {
    leadCardType: 'PROGRAM'
  },
  'place-cards': {
    leadCardType: 'PLACE_CARDS'
  },
  'holiday-cards': {
    leadCardType: 'HOLIDAY'
  }
};

export const PLP_EVENTS_AND_TITLES = {
  invitations: {
    activeCardEvent: 'INVITATION',
    pageTitle: 'Affordable Wedding Invitations | Hundreds of Templates & Samples',
    metaDescription: 'Discover wedding invitations that will leave your guests breathless. Explore beautiful designs & choose an invite that sets the perfect tone for your big day.',
    metaKeywords: 'Wedding invites,Wedding invitations,wedding invitation templates,Wedding invitation cards,Sample wedding invitations,Wedding invitation design,Wedding envelopes',
    canonical: `https://${window.location.hostname}/wedding-planning/invitations/shop`,
  },
  'thank-you-cards': {
    activeCardEvent: 'THANK_YOU',
    pageTitle: 'Thank You Cards to Match Your Save The Dates, Invitations, and Wedding Website',
    metaDescription: 'Find wedding thank you cards that will charm & delight your guests. Choose from dozens of beautiful designs to match your wedding theme and order in minutes.',
    metaKeywords: 'Wedding thank you cards,Custom thank you cards,Wedding thank you',
    canonical: `https://${window.location.hostname}/wedding-planning/thank-you-cards/shop`,
  },
  menus: {
    activeCardEvent: 'MENU',
    pageTitle: 'Affordable Menus for your Wedding Reception | Hundreds of Templates & Samples',
    metaDescription: 'Create a beautiful dining experience with the perfect wedding menu. Choose from dozens of elegant and charming designs and styles to match any wedding theme.',
    metaKeywords: 'Wedding menu,wedding menu cards,menu cards,wedding reception food menu',
    canonical: `https://${window.location.hostname}/wedding-planning/menus/shop`,
  },
  programs: {
    activeCardEvent: 'PROGRAM',
    pageTitle: 'Affordable Wedding Programs | Hundreds of Templates & Samples',
    metaDescription: 'Get the perfect program for your wedding day. Choose from dozens of charming designs to match your wedding theme and style & order with a few clicks.',
    metaKeywords: 'Wedding programs,Wedding programs template,Ceremony program,Ceremony program template',
    canonical: `https://${window.location.hostname}/wedding-planning/programs/shop`,
  },
  enclosures: {
    activeCardEvent: 'DETAILS',
    pageTitle: 'Affordable Enclosure Cards | Hundreds of Templates & Samples',
    metaDescription: 'Get beautiful & elegant enclosure cards for your wedding. Choose from dozens of alluring designs that match your wedding theme & order with a few clicks.',
    canonical: `https://${window.location.hostname}/wedding-planning/enclosures/shop`,
  },
  'place-cards': {
    activeCardEvent: 'PLACE_CARDS',
    pageTitle: 'Affordable Place Cards | Hundreds of Templates & Samples'
  },
  'save-the-date': {
    activeCardEvent: 'SAVE_THE_DATE',
    pageTitle: 'Save The Date Cards for Weddings - Free Shipping | Zola',
    metaDescription: 'Find a perfect Save The Date card for your wedding in minutes. Choose from beautiful designs and gorgeous imagery that sets the tone for your special day.',
    metaKeywords: 'save the date,Save the date cards,save the date magnets,Save the date wedding,Save the date invitations',
    canonical: `https://${window.location.hostname}/wedding-planning/save-the-date/shop`,
  },
  'change-the-date': {
    activeCardEvent: 'CHANGE_THE_DATE',
    pageTitle: 'Change The Date Cards for Weddings - Free Shipping | Zola',
    metaDescription: 'Find a Change The Date card to update guests if your wedding plans have changed. Get wording tips, free guest addressing, free back-of-card printing, and more.',
    canonical: `https://${window.location.hostname}/wedding-planning/change-the-date/shop`,
  },
  'holiday-cards': {
    activeCardEvent: 'HOLIDAY',
    pageTitle: 'Affordable Holiday Cards | Unique Templates & Designs',
    canonical: `https://${window.location.hostname}/wedding-planning/holiday-cards/shop`,
  }
};


// WEBPACK FOOTER //
// ./src/cards/constants/CardTypes.js